// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1050;
}

.modal-container {
	background-color: #fff;
	border-radius: 20px;
	box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
	padding: 2rem;
	width: 60%;
	max-width: 800px;
	max-height: 80%;
	overflow-y: auto;
}

.modal-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem;
}

.modal-top-info {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}

.modal-employee-info {
	display: flex;
	gap: 1rem;
	align-items: center;
}

.employee-name {
	color: var(--Secondary-Blue-800, #00557c);
	font-size: 21.6px;
	font-weight: bold;
	line-height: 28.8px;
}

.employee-role {
	color: #41c8ff;
	font-size: 19.2px;
	font-weight: 500;
	line-height: 26.4px;
}

.modal-progress-info {
	display: flex;
	align-items: center;
	gap: 1rem;
	max-width: 240px;
}

.modal-employe-avatar {
	width: 53px;
	height: 53px;
	border-radius: 50%;
	overflow: hidden;
}

.modal-assign {
	max-width: 900px !important;
	width: 100%;
}

.modal-employe-avatar img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.progress-text {
	color: var(--Primary-Purple-700, #584ec0);
	font-size: 18px;
	font-weight: 500;
	line-height: 24px;
}

.modal-body {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	gap: 1rem;
	margin-bottom: 2rem;
}

.modal-info-card {
	background: #f8f9fa;
	padding: 1rem;
	display: flex;
	/* width: max-content; */
	justify-content: space-between;
	align-items: center;
	border-radius: 8px;
	gap: 1rem;
	min-height: 120px;
	max-height: 120px;
	height: 100%;
	border: 1px solid var(--Grey-400, #d8dae5);
}
.flex {
	display: flex;
	align-items: center;
	gap: 8px;
}

.flex-col {
	display: flex;
	gap: 8px;
	flex-direction: column;
}

.checkbox > div.disabled {
	opacity: 0.5;
}
.checkbox > div.disabled input[type='checkbox'] {
	caret-color: #edeff5;
}
.checkbox input[type='checkbox'] {
	caret-color: #7a6be8;
}
.divider {
	margin-block: 5rem;
}
.modal-flex {
	display: flex;
	flex-wrap: wrap;
	gap: 1rem 0;
	justify-content: space-between;
}

.modal-flex .row {
	margin-bottom: 2rem;
}

.modal-info-title,
.info-answer,
.info-tag {
	color: var(--Secondary-Blue-800, #00557c);
	font-size: 18px;
	font-weight: 500;
	line-height: 24px;
}

.activities {
	display: flex;
	flex-direction: column;
	overflow: hidden;
	border-radius: 8px;
	border: 1px solid #7a6be8;
}

.activities .activities-info {
	border-bottom: 1px solid #7a6be8;
	background: #7a6be8;
	padding: 2px 28px;

	color: #fff;
	text-align: center;
	font-size: 18px;
	font-weight: 500;
	line-height: 24px;
}

.activities .activities-content {
	color: #6d60db;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	padding: 1rem;
}

.info-answer > div {
	display: flex;
	gap: 10px;
}

.info-answer span {
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
}
.info-answer span.error {
	color: #7a0000;
}

.info-answer span.success {
	color: #007500;
}

.info-icon {
	font-size: 2.5rem;
	margin-bottom: 0.5rem;
}

.info-icon.positive {
	color: #28a745;
}

.info-icon.negative {
	color: #dc3545;
}

.modal-additional {
	background: #f8f9fa;
	border-radius: 10px;
	padding: 10px;
	margin-top: 1rem;
}

.modal-additional h3 {
	color: #00557c;
	font-size: 18px;
	font-weight: 500;
	line-height: 24px;
}
.modal-additional hr {
	background-color: #abacb1;
}

.modal-additional p {
	color: #444258;
	font-family: Noto Sans;
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	padding: 10px;
}

.modal-close-button {
	background: none;
	border: none;
	font-size: 1.5rem;
	color: #333;
	cursor: pointer;
}

.program {
	align-items: flex-end;
}

.info-tag .square {
	display: block;
	width: 13px;
	height: 13px;
	border-radius: 2px;
}
.info-tag .square.high {
	background: #7a6be8;
}
.info-tag .square.middle {
	background: #b2bff2;
}
.info-tag .square.low {
	background: #edeff5;
}
.program .lines {
	width: 24px;
	max-height: 81px;
	border-radius: 50px 50px 0px 0px;
}

.program .lines.line-one {
	height: 81px;
	background: #7a6be8;
}

.program .lines.line-two {
	height: 55px;
	background: #b2bff2;
}
.program .lines.line-three {
	height: 35px;
	background: #edeff5;
}

.modal-footer {
	display: flex;
	justify-content: flex-end;
	margin-top: 1rem;
}

.close-modal-button {
	padding: 0.5rem 1rem;
	background-color: #007bff;
	color: white;
	border: none;
	border-radius: 5px;
	cursor: pointer;
	font-size: 1rem;
}

.close-modal-button:hover {
	background-color: #0056b3;
}

@property --progress-value {
	syntax: '<integer>';
	inherits: false;
	initial-value: 0;
}

/* @keyframes progress-circle {
    to { --progress-value: 73; }
} */

.modal-progress-bar {
	width: 100px;
	height: 100px;
	border-radius: 50%;

	/* to center the percentage value */
	display: flex;
	justify-content: center;
	align-items: center;
}

.modal-progress-bar::before {
	/* counter-reset: percentage var(--progress-value);
    content: counter(percentage) '%'; */
	content: attr(data-progress) '%';
	color: #453d9e;
	text-align: center;
	font-size: 20.006px;
	font-weight: 700;
	line-height: 25.007px;
}

.progress-circle {
	background: radial-gradient(closest-side, white 79%, transparent 80% 100%, white 0), conic-gradient(#7a6be8 calc(var(--progress-value) * 1%), #e2d6ff 0);
	animation: progress-circle 2s 1 forwards;
}

.progress-circle::before {
	animation: progress-circle 2s 1 forwards;
}

progress {
	visibility: hidden;
	width: 0;
	height: 0;
}
`, "",{"version":3,"sources":["webpack://./src/Views/Services/Components/AssignScreen/Components/ModalAssignScreen.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,oCAAoC;CACpC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,aAAa;AACd;;AAEA;CACC,sBAAsB;CACtB,mBAAmB;CACnB,2CAA2C;CAC3C,aAAa;CACb,UAAU;CACV,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,yCAAyC;CACzC,iBAAiB;CACjB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,yCAAyC;CACzC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,2DAA2D;CAC3D,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,aAAa;CACb,wBAAwB;CACxB,8BAA8B;CAC9B,mBAAmB;CACnB,kBAAkB;CAClB,SAAS;CACT,iBAAiB;CACjB,iBAAiB;CACjB,YAAY;CACZ,0CAA0C;AAC3C;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,YAAY;AACb;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,eAAe;CACf,WAAW;CACX,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;;CAGC,yCAAyC;CACzC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,gBAAgB;CAChB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;CAChC,mBAAmB;CACnB,iBAAiB;;CAEjB,WAAW;CACX,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,sBAAsB;CACtB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,iBAAiB;CACjB,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,gCAAgC;AACjC;;AAEA;CACC,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,yBAAyB;CACzB,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,gBAAgB;AACjB;;AAEA;;GAEG;;AAEH;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;;CAElB,mCAAmC;CACnC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC;uCACsC;CACtC,gCAAgC;CAChC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,wJAAwJ;CACxJ,wCAAwC;AACzC;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;AACV","sourcesContent":[".modal-backdrop {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: rgba(0, 0, 0, 0.5);\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tz-index: 1050;\r\n}\r\n\r\n.modal-container {\r\n\tbackground-color: #fff;\r\n\tborder-radius: 20px;\r\n\tbox-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);\r\n\tpadding: 2rem;\r\n\twidth: 60%;\r\n\tmax-width: 800px;\r\n\tmax-height: 80%;\r\n\toverflow-y: auto;\r\n}\r\n\r\n.modal-header {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tmargin-bottom: 1rem;\r\n}\r\n\r\n.modal-top-info {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\twidth: 100%;\r\n}\r\n\r\n.modal-employee-info {\r\n\tdisplay: flex;\r\n\tgap: 1rem;\r\n\talign-items: center;\r\n}\r\n\r\n.employee-name {\r\n\tcolor: var(--Secondary-Blue-800, #00557c);\r\n\tfont-size: 21.6px;\r\n\tfont-weight: bold;\r\n\tline-height: 28.8px;\r\n}\r\n\r\n.employee-role {\r\n\tcolor: #41c8ff;\r\n\tfont-size: 19.2px;\r\n\tfont-weight: 500;\r\n\tline-height: 26.4px;\r\n}\r\n\r\n.modal-progress-info {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 1rem;\r\n\tmax-width: 240px;\r\n}\r\n\r\n.modal-employe-avatar {\r\n\twidth: 53px;\r\n\theight: 53px;\r\n\tborder-radius: 50%;\r\n\toverflow: hidden;\r\n}\r\n\r\n.modal-assign {\r\n\tmax-width: 900px !important;\r\n\twidth: 100%;\r\n}\r\n\r\n.modal-employe-avatar img {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tobject-fit: cover;\r\n}\r\n\r\n.progress-text {\r\n\tcolor: var(--Primary-Purple-700, #584ec0);\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tline-height: 24px;\r\n}\r\n\r\n.modal-body {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n\tgap: 1rem;\r\n\tmargin-bottom: 2rem;\r\n}\r\n\r\n.modal-info-card {\r\n\tbackground: #f8f9fa;\r\n\tpadding: 1rem;\r\n\tdisplay: flex;\r\n\t/* width: max-content; */\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tborder-radius: 8px;\r\n\tgap: 1rem;\r\n\tmin-height: 120px;\r\n\tmax-height: 120px;\r\n\theight: 100%;\r\n\tborder: 1px solid var(--Grey-400, #d8dae5);\r\n}\r\n.flex {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n}\r\n\r\n.flex-col {\r\n\tdisplay: flex;\r\n\tgap: 8px;\r\n\tflex-direction: column;\r\n}\r\n\r\n.checkbox > div.disabled {\r\n\topacity: 0.5;\r\n}\r\n.checkbox > div.disabled input[type='checkbox'] {\r\n\tcaret-color: #edeff5;\r\n}\r\n.checkbox input[type='checkbox'] {\r\n\tcaret-color: #7a6be8;\r\n}\r\n.divider {\r\n\tmargin-block: 5rem;\r\n}\r\n.modal-flex {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 1rem 0;\r\n\tjustify-content: space-between;\r\n}\r\n\r\n.modal-flex .row {\r\n\tmargin-bottom: 2rem;\r\n}\r\n\r\n.modal-info-title,\r\n.info-answer,\r\n.info-tag {\r\n\tcolor: var(--Secondary-Blue-800, #00557c);\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tline-height: 24px;\r\n}\r\n\r\n.activities {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\toverflow: hidden;\r\n\tborder-radius: 8px;\r\n\tborder: 1px solid #7a6be8;\r\n}\r\n\r\n.activities .activities-info {\r\n\tborder-bottom: 1px solid #7a6be8;\r\n\tbackground: #7a6be8;\r\n\tpadding: 2px 28px;\r\n\r\n\tcolor: #fff;\r\n\ttext-align: center;\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tline-height: 24px;\r\n}\r\n\r\n.activities .activities-content {\r\n\tcolor: #6d60db;\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n\tline-height: 20px;\r\n\tpadding: 1rem;\r\n}\r\n\r\n.info-answer > div {\r\n\tdisplay: flex;\r\n\tgap: 10px;\r\n}\r\n\r\n.info-answer span {\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n\tline-height: 20px;\r\n}\r\n.info-answer span.error {\r\n\tcolor: #7a0000;\r\n}\r\n\r\n.info-answer span.success {\r\n\tcolor: #007500;\r\n}\r\n\r\n.info-icon {\r\n\tfont-size: 2.5rem;\r\n\tmargin-bottom: 0.5rem;\r\n}\r\n\r\n.info-icon.positive {\r\n\tcolor: #28a745;\r\n}\r\n\r\n.info-icon.negative {\r\n\tcolor: #dc3545;\r\n}\r\n\r\n.modal-additional {\r\n\tbackground: #f8f9fa;\r\n\tborder-radius: 10px;\r\n\tpadding: 10px;\r\n\tmargin-top: 1rem;\r\n}\r\n\r\n.modal-additional h3 {\r\n\tcolor: #00557c;\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tline-height: 24px;\r\n}\r\n.modal-additional hr {\r\n\tbackground-color: #abacb1;\r\n}\r\n\r\n.modal-additional p {\r\n\tcolor: #444258;\r\n\tfont-family: Noto Sans;\r\n\tfont-size: 16px;\r\n\tfont-weight: 400;\r\n\tline-height: 24px;\r\n\tpadding: 10px;\r\n}\r\n\r\n.modal-close-button {\r\n\tbackground: none;\r\n\tborder: none;\r\n\tfont-size: 1.5rem;\r\n\tcolor: #333;\r\n\tcursor: pointer;\r\n}\r\n\r\n.program {\r\n\talign-items: flex-end;\r\n}\r\n\r\n.info-tag .square {\r\n\tdisplay: block;\r\n\twidth: 13px;\r\n\theight: 13px;\r\n\tborder-radius: 2px;\r\n}\r\n.info-tag .square.high {\r\n\tbackground: #7a6be8;\r\n}\r\n.info-tag .square.middle {\r\n\tbackground: #b2bff2;\r\n}\r\n.info-tag .square.low {\r\n\tbackground: #edeff5;\r\n}\r\n.program .lines {\r\n\twidth: 24px;\r\n\tmax-height: 81px;\r\n\tborder-radius: 50px 50px 0px 0px;\r\n}\r\n\r\n.program .lines.line-one {\r\n\theight: 81px;\r\n\tbackground: #7a6be8;\r\n}\r\n\r\n.program .lines.line-two {\r\n\theight: 55px;\r\n\tbackground: #b2bff2;\r\n}\r\n.program .lines.line-three {\r\n\theight: 35px;\r\n\tbackground: #edeff5;\r\n}\r\n\r\n.modal-footer {\r\n\tdisplay: flex;\r\n\tjustify-content: flex-end;\r\n\tmargin-top: 1rem;\r\n}\r\n\r\n.close-modal-button {\r\n\tpadding: 0.5rem 1rem;\r\n\tbackground-color: #007bff;\r\n\tcolor: white;\r\n\tborder: none;\r\n\tborder-radius: 5px;\r\n\tcursor: pointer;\r\n\tfont-size: 1rem;\r\n}\r\n\r\n.close-modal-button:hover {\r\n\tbackground-color: #0056b3;\r\n}\r\n\r\n@property --progress-value {\r\n\tsyntax: '<integer>';\r\n\tinherits: false;\r\n\tinitial-value: 0;\r\n}\r\n\r\n/* @keyframes progress-circle {\r\n    to { --progress-value: 73; }\r\n} */\r\n\r\n.modal-progress-bar {\r\n\twidth: 100px;\r\n\theight: 100px;\r\n\tborder-radius: 50%;\r\n\r\n\t/* to center the percentage value */\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.modal-progress-bar::before {\r\n\t/* counter-reset: percentage var(--progress-value);\r\n    content: counter(percentage) '%'; */\r\n\tcontent: attr(data-progress) '%';\r\n\tcolor: #453d9e;\r\n\ttext-align: center;\r\n\tfont-size: 20.006px;\r\n\tfont-weight: 700;\r\n\tline-height: 25.007px;\r\n}\r\n\r\n.progress-circle {\r\n\tbackground: radial-gradient(closest-side, white 79%, transparent 80% 100%, white 0), conic-gradient(#7a6be8 calc(var(--progress-value) * 1%), #e2d6ff 0);\r\n\tanimation: progress-circle 2s 1 forwards;\r\n}\r\n\r\n.progress-circle::before {\r\n\tanimation: progress-circle 2s 1 forwards;\r\n}\r\n\r\nprogress {\r\n\tvisibility: hidden;\r\n\twidth: 0;\r\n\theight: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
